import { render, staticRenderFns } from "./CitiesList.vue?vue&type=template&id=61ad1660&scoped=true"
import script from "./CitiesList.vue?vue&type=script&lang=js"
export * from "./CitiesList.vue?vue&type=script&lang=js"
import style0 from "./CitiesList.vue?vue&type=style&index=0&id=61ad1660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad1660",
  null
  
)

export default component.exports